import type { NextApiResponse, NextPageContext } from 'next';

import { getRedirectUrl } from 'Components/RouterMiddleware/RouterMiddleware.helpers';

export const getServerSideLoginPageRedirect = (context: NextPageContext): NextApiResponse => {
	// @ts-expect-error - Property 'redirect' does not exist on type 'ServerResponse<IncomingMessage>'.
	return context.res?.redirect(302, getRedirectUrl(context?.req?.url));
};
